import type { Maybe } from '@adornis/base/utilTypes';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { Folder } from '../db/Folder';
import { LASFile } from '../db/LASFile';

export const deleteFolderRecursive = registerQuery({
  type: () => String,
  operationName: 'deleteFolderRecursive',
  resolve: (folderID: Maybe<string>) => {
    return async () => {
      if (!folderID) return 'Kein Ordner angegeben';

      const rawFolderCollection = await getRawCollection<Folder>(Folder._collectionName);
      const rawFileCollection = await getRawCollection(LASFile._collectionName);

      // Rekursive Funktion zum Löschen von Ordnern und deren Inhalten
      async function deleteFolder(currentFolderID: string): Promise<void> {
        // Alle Unterordner finden
        const subFolders = await rawFolderCollection.find<Folder>({ parentFolderID: currentFolderID }).toArray();

        // Rekursiv alle Unterordner löschen
        for (const subFolder of subFolders) {
          await deleteFolder(subFolder._id);
        }

        // Alle Dateien im aktuellen Ordner löschen
        const files = await rawFileCollection.find<LASFile>({ parentFolderID: currentFolderID }).toArray();
        for (const fileID of files) {
          await LASFile.removeFile(fileID._id)().catch(e => {
            console.error('Fehler beim Löschen der Datei:', e);
          });
        }

        // Den Ordner selbst löschen
        await rawFolderCollection.deleteOne({ _id: currentFolderID });
      }

      try {
        await deleteFolder(folderID);
        return 'Ordner erfolgreich gelöscht';
      } catch (error) {
        console.error('Fehler beim Löschen des Ordners:', error);
        return 'Fehler beim Löschen des Ordners';
      }
    };
  },
  params: [{ name: 'folderID', type: () => String }],
});
